import React from 'react';

import { useParams } from 'react-router-dom';

import BnplAcceptInvite from '../components/Bnpl/BnplAcceptInvite';
import Layout from '../components/common/Layout';
import { getTenant } from '../config';
import { apiBaseUrl } from '../service/api';

export default function AcceptInvite() {
  const pathnames = useParams();
  const inviteCode = pathnames.inviteCode;

  const inviteRedirect = () => {
    window.location.href = `${apiBaseUrl}/account/signin/code/${inviteCode}`;
  };

  if (getTenant() === 'lightrx') {
    return <BnplAcceptInvite inviteRedirect={inviteRedirect} />;
  }

  return (
    <Layout>
      <div className="bnpl-form">
        <div className={`bnpl-form__title`}>
          <h1>
            Hello, click on the button below to accept the invitation. Accepting the invite will
            redirect you to the application
          </h1>
        </div>
        <div className={`bnpl-form__button-container`}>
          <button onClick={inviteRedirect}>Apply for Financing</button>
        </div>
      </div>
    </Layout>
  );
}
